var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VOTE_STATUS } from "../components/desktopApp/longread/postblocks/VoteBlock/votepostwithcollect";
var getTotalCount = function (vote) { return vote.map(function (i) { return Number(i.votesCount); }).reduce(function (sum, current) { return sum + current; }, 0); };
var getTotalPercent = function (totalCount, count) {
    var total = (count * 100) / totalCount;
    if (total === 0 || isNaN(total))
        return 0;
    return total.toFixed();
};
//возвращает стадию ( последняя = текущая )
var computedStage = function (data) { var _a, _b, _c; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.stages[((_c = (_b = data['pollData']) === null || _b === void 0 ? void 0 : _b.stages) === null || _c === void 0 ? void 0 : _c.length) - 1]; };
var computedStageList = function (data) { var _a; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.stages; };
var computeEntityId = function (data) { var _a; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.id; };
var computeAutoStageVoteCount = function (data) { var _a; return ((_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.autoStageVoteCount) || 0; };
var computeVoteStatus = function (data) { var _a; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.status; };
var computeWinner = function (data, status) {
    var _a, _b, _c, _d, _e, _f;
    return status === VOTE_STATUS['end'] ?
        (_f = (_e = (_d = (_c = (_b = (_a = computedStage(data)) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.candidates) === null || _d === void 0 ? void 0 : _d.reduce(function (acc, val) { return (val === null || val === void 0 ? void 0 : val.votesCount) > (acc === null || acc === void 0 ? void 0 : acc.votesCount) ? val : acc; })) === null || _e === void 0 ? void 0 : _e.entity) === null || _f === void 0 ? void 0 : _f.entityId :
        '';
};
export var calculatePercents = function (counts) {
    var total = counts.reduce(function (sum, c) { return sum + c; }, 0);
    if (total === 0)
        return counts.map(function () { return 0; });
    var rawPercents = counts.map(function (c) { return (c / total) * 100; });
    var floored = rawPercents.map(Math.floor);
    var sumFloored = floored.reduce(function (a, b) { return a + b; }, 0);
    var remains = 100 - sumFloored;
    if (remains > 0) {
        var indexedFloored = floored.map(function (value, index) { return ({ index: index, value: value }); }).sort(function (a, b) {
            return b.value - a.value;
        });
        for (var i = 0; i < remains; i++) {
            floored[indexedFloored[i].index]++;
        }
    }
    return floored;
};
//возвращает сущности для голосования
var computeCandidate = function (data, customStage) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (customStage === void 0) { customStage = undefined; }
    return (_g = (_f = (_e = (_b = (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b[customStage === undefined ? (((_d = (_c = data['pollData']) === null || _c === void 0 ? void 0 : _c.stages) === null || _d === void 0 ? void 0 : _d.length) - 1) : customStage]) === null || _e === void 0 ? void 0 : _e.groups) === null || _f === void 0 ? void 0 : _f.map(function (i, idx, arr) {
        var _a;
        return (_a = i === null || i === void 0 ? void 0 : i.candidates) === null || _a === void 0 ? void 0 : _a.map(function (k) { return (__assign(__assign({}, k), { groupId: i === null || i === void 0 ? void 0 : i.id })); });
    })) === null || _g === void 0 ? void 0 : _g.map(function (candidates) {
        var counts = candidates.map(function (val) { return (val === null || val === void 0 ? void 0 : val.votesCount) || 0; });
        var percents = calculatePercents(counts);
        return candidates.map(function (val, idx) {
            var _a;
            return ({
                id: (_a = val === null || val === void 0 ? void 0 : val.entity) === null || _a === void 0 ? void 0 : _a.entityId,
                groupId: val === null || val === void 0 ? void 0 : val.groupId,
                count: (val === null || val === void 0 ? void 0 : val.votesCount) || 0,
                accountIds: (val === null || val === void 0 ? void 0 : val.accountIds) || [],
                isModerVoted: (val === null || val === void 0 ? void 0 : val.isModerVoted) || false,
                percent: percents[idx],
                title: (val === null || val === void 0 ? void 0 : val.title) || []
            });
        });
    });
};
//возвращает сущности для голосования
var computeCandidateList = function (data) {
    var _a, _b;
    return Array((_b = (_a = data === null || data === void 0 ? void 0 : data.pollData) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b.length).fill(0).map(function (i, index) { return computeCandidate(data, index); });
};
export var computeVoteCollection = function (data) {
    return {
        voteCollection: computeCandidate(data),
        voteCollectionList: computeCandidateList(data),
        stage: computedStage(data),
        stageList: computedStageList(data),
        entityId: computeEntityId(data),
        autoStageVoteCount: computeAutoStageVoteCount(data),
        status: computeVoteStatus(data),
        winnerId: computeWinner(data, computeVoteStatus(data))
    };
};
export var getCollectionElement = function (data, fnd) { var _a, _b; return (_b = (_a = data === null || data === void 0 ? void 0 : data.map(function (i) { return i.filter(function (k) { return k.id === fnd; }); })) === null || _a === void 0 ? void 0 : _a.find(function (i) { return !!i.length; })) === null || _b === void 0 ? void 0 : _b[0]; };
//# sourceMappingURL=computeVote.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VOTE_STATUS } from "../components/desktopApp/longread/postblocks/VoteBlock/votepostwithcollect";
var getTotalCount = function (vote) { return vote.map(function (i) { return Number(i.votesCount); }).reduce(function (sum, current) { return sum + current; }, 0); };
var getTotalPercent = function (totalCount, count) {
    var total = (count * 100) / totalCount;
    if (total === 0 || isNaN(total))
        return 0;
    return total.toFixed();
};
//возвращает стадию ( последняя = текущая )
var computedStage = function (data) { var _a, _b, _c; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.stages[((_c = (_b = data['pollData']) === null || _b === void 0 ? void 0 : _b.stages) === null || _c === void 0 ? void 0 : _c.length) - 1]; };
var computedStageList = function (data) { var _a; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.stages; };
var computeEntityId = function (data) { var _a; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.id; };
var computeAutoStageVoteCount = function (data) { var _a; return ((_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.autoStageVoteCount) || 0; };
var computeVoteStatus = function (data) { var _a; return (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.status; };
var computeWinner = function (data, status) {
    var _a, _b, _c, _d, _e, _f;
    return status === VOTE_STATUS['end'] ?
        (_f = (_e = (_d = (_c = (_b = (_a = computedStage(data)) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.candidates) === null || _d === void 0 ? void 0 : _d.reduce(function (acc, val) { return (val === null || val === void 0 ? void 0 : val.votesCount) > (acc === null || acc === void 0 ? void 0 : acc.votesCount) ? val : acc; })) === null || _e === void 0 ? void 0 : _e.entity) === null || _f === void 0 ? void 0 : _f.entityId :
        '';
};
export var calculatePercents = function (counts) {
    var total = counts.reduce(function (sum, c) { return sum + c; }, 0);
    if (total === 0)
        return counts.map(function () { return 0; });
    var rawPercents = counts.map(function (c) { return (c / total) * 100; });
    var floored = rawPercents.map(Math.floor);
    var sumFloored = floored.reduce(function (a, b) { return a + b; }, 0);
    var remains = 100 - sumFloored;
    if (remains > 0) {
        var indexedFloored = floored.map(function (value, index) { return ({ index: index, value: value }); }).sort(function (a, b) {
            return b.value - a.value;
        });
        for (var i = 0; i < remains; i++) {
            floored[indexedFloored[i].index]++;
        }
    }
    return floored;
};
//возвращает сущности для голосования
var computeCandidate = function (data, customStage) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (customStage === void 0) { customStage = undefined; }
    return (_g = (_f = (_e = (_b = (_a = data['pollData']) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b[customStage === undefined ? (((_d = (_c = data['pollData']) === null || _c === void 0 ? void 0 : _c.stages) === null || _d === void 0 ? void 0 : _d.length) - 1) : customStage]) === null || _e === void 0 ? void 0 : _e.groups) === null || _f === void 0 ? void 0 : _f.map(function (i, idx, arr) {
        var _a;
        return (_a = i === null || i === void 0 ? void 0 : i.candidates) === null || _a === void 0 ? void 0 : _a.map(function (k) { return (__assign(__assign({}, k), { groupId: i === null || i === void 0 ? void 0 : i.id })); });
    })) === null || _g === void 0 ? void 0 : _g.map(function (candidates) {
        var counts = candidates.map(function (val) { return (val === null || val === void 0 ? void 0 : val.votesCount) || 0; });
        var percents = calculatePercents(counts);
        return candidates.map(function (val, idx) {
            var _a;
            return ({
                id: (_a = val === null || val === void 0 ? void 0 : val.entity) === null || _a === void 0 ? void 0 : _a.entityId,
                groupId: val === null || val === void 0 ? void 0 : val.groupId,
                count: (val === null || val === void 0 ? void 0 : val.votesCount) || 0,
                accountIds: (val === null || val === void 0 ? void 0 : val.accountIds) || [],
                isModerVoted: (val === null || val === void 0 ? void 0 : val.isModerVoted) || false,
                percent: percents[idx],
                title: (val === null || val === void 0 ? void 0 : val.title) || []
            });
        });
    });
};
//возвращает сущности для голосования
var computeCandidateList = function (data) {
    var _a, _b;
    return Array((_b = (_a = data === null || data === void 0 ? void 0 : data.pollData) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b.length).fill(0).map(function (i, index) { return computeCandidate(data, index); });
};
export var computeVoteCollection = function (data) {
    return {
        voteCollection: computeCandidate(data),
        voteCollectionList: computeCandidateList(data),
        stage: computedStage(data),
        stageList: computedStageList(data),
        entityId: computeEntityId(data),
        autoStageVoteCount: computeAutoStageVoteCount(data),
        status: computeVoteStatus(data),
        winnerId: computeWinner(data, computeVoteStatus(data))
    };
};
export var getCollectionElement = function (data, fnd) { var _a, _b; return (_b = (_a = data === null || data === void 0 ? void 0 : data.map(function (i) { return i.filter(function (k) { return k.id === fnd; }); })) === null || _a === void 0 ? void 0 : _a.find(function (i) { return !!i.length; })) === null || _b === void 0 ? void 0 : _b[0]; };
//# sourceMappingURL=computeVote.js.map